import {Base} from "@/api/Base"

export class AuthorityEdit extends Base {
    path = "authority/edit"
}